var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup444(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#748d6f}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    transform: "translate(-735 -604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_662",
    fill: "none",
    d: "M0 0H39V39H0z",
    transform: "translate(735 604)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_002-wall-clock",
    transform: "translate(739 608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    d: "M15.024 0a15.024 15.024 0 1 0 15.024 15.024A15.041 15.041 0 0 0 15.024 0zm0 27.855a12.831 12.831 0 1 1 12.831-12.831 12.845 12.845 0 0 1-12.831 12.831z",
    className: "cls-2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    transform: "translate(12.627 6.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    d: "M232.622 133.78h-5.313v-7.356a1.226 1.226 0 1 0-2.452 0v8.583a1.226 1.226 0 0 0 1.226 1.226h6.539a1.226 1.226 0 1 0 0-2.452z",
    className: "cls-2",
    transform: "translate(-224.857 -125.197)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup444);
export default __webpack_public_path__ + "static/media/Group 444.2d2abcca654c128746972f77fb724d60.svg";
export { ForwardRef as ReactComponent };